import LoadingPage from "@/pages/utils/loading.page";
import { useAccountSnapshot } from "@/stores/account.store";
import { Navigate } from "react-router-dom";

const PublicPage = (props: { children: JSX.Element }) => {
  const { isLoading, isLogged } = useAccountSnapshot();
  if (isLoading) {
    return <LoadingPage />;
  }

  if (!isLogged) {
    return props.children;
  }

  if (isLogged) {
    return <Navigate to={"/"} />;
  }
};

export default PublicPage;
